export const WS_ON_MESSAGE = 'Websocket.Onmessage';
export const WS_ON_MESSAGE_EVENT_CONFIRMED = 'Websocket.Onmessage.Event.Confirmed';




// WEBPACK FOOTER //
// ./src/Types/Websocket.js